import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white mt-16" data-id="element-44">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-45">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-46">
          {/* Company Info */}
          <div data-id="element-47">
            <h3 className="text-xl font-bold text-red-500 mb-4" data-id="element-48">Buy Spot</h3>
            <p className="text-gray-400 text-sm" data-id="element-49">
              Your one-stop shop for all things Christmas. Quality decorations
              and gifts for the perfect holiday season.
            </p>
          </div>
          {/* Quick Links */}
          <div data-id="element-50">
            <h4 className="font-semibold mb-4" data-id="element-51">Shop</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-52">
              <li data-id="element-53">
                <a href="#" className="hover:text-white transition" data-id="element-54">
                  All Products
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="hover:text-white transition" data-id="element-56">
                  New Arrivals
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="hover:text-white transition" data-id="element-58">
                  Best Sellers
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="hover:text-white transition" data-id="element-60">
                  Sale
                </a>
              </li>
            </ul>
          </div>
          {/* Customer Service */}
          <div data-id="element-61">
            <h4 className="font-semibold mb-4" data-id="element-62">Customer Service</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-63">
              <li data-id="element-64">
                <a href="#" className="hover:text-white transition" data-id="element-65">
                  Contact Us
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="hover:text-white transition" data-id="element-67">
                  Shipping Info
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="hover:text-white transition" data-id="element-69">
                  Returns
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-white transition" data-id="element-71">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          {/* Newsletter */}
          <div data-id="element-72">
            <h4 className="font-semibold mb-4" data-id="element-73">Stay Connected</h4>
            <p className="text-sm text-gray-400 mb-4" data-id="element-74">
              Subscribe for exclusive deals and updates
            </p>
            <div className="flex gap-2 mb-4" data-id="element-75">
              <input type="email" placeholder="Your email" className="flex-1 px-3 py-2 bg-gray-800 text-white rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-red-500" data-id="element-76" />
              <button className="bg-red-600 p-2 rounded-md hover:bg-red-700 transition" data-id="element-77">
                <MailIcon className="w-5 h-5" data-id="element-78" />
              </button>
            </div>
            <div className="flex gap-3" data-id="element-79">
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-80">
                <FacebookIcon className="w-5 h-5" data-id="element-81" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-82">
                <InstagramIcon className="w-5 h-5" data-id="element-83" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-84">
                <TwitterIcon className="w-5 h-5" data-id="element-85" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400" data-id="element-86">
          <p data-id="element-87">&copy; 2024 Buy Spot. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}